var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showNavbar)?_c('Navbar',{attrs:{"routes":_vm.routes}}):_vm._e(),_c('main',{staticClass:"container"},[_c('section',{attrs:{"id":"main"}},[_c('router-view',{attrs:{"fullSite":_vm.fullSite,"showHero":_vm.showHero}})],1),(_vm.showFooter)?_c('Footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }